import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ChartAccumulatedLosses from './Charts/ChartAccumulatedLosses';
import CustomWidget from '../Custom/CustomWidget';
import ChartEfficiencyChange from './Charts/ChartEfficiencyChange';
import ChartEfficiencyOverTime from './Charts/ChartEfficiencyOverTime';
import ChartRealTimeEfficience from './Charts/ChartRealTimeEfficiency';

const TabEnergy = ({ hirarchy }) => {
  const props = {
    type: hirarchy.type.label,
    id: hirarchy.level.value,
    units: hirarchy.units,
  };
  return (
    <>
      <Row>
        <Col lg={12}>
          <CustomWidget
            size={8}
            id={'chrtEfficiencyOverTime'}
            title={'Energy Efficiency Over Time'}
          >
            <ChartEfficiencyOverTime {...props} />
          </CustomWidget>
          <Col lg={4}>
            <CustomWidget size={12} id={'chrtRealTimeEfficience'}>
              <ChartRealTimeEfficience {...props} />
            </CustomWidget>
            <CustomWidget size={12} id={'chrtAccumulatedLosses'}>
              <ChartAccumulatedLosses {...props} />
            </CustomWidget>
            <CustomWidget size={12} id={'chrtEfficiencyChange'}>
              <ChartEfficiencyChange {...props} />
            </CustomWidget>
          </Col>
        </Col>
      </Row>
    </>
  );
};

export default TabEnergy;
